import { Component, Input } from '@angular/core';
import { PassportProduct  } from '@app/core/interfaces';
import { RelationInterface } from 'outshared-lib';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@Component({
    selector: 'ins-passport',
    templateUrl: './passport.component.html',
})
export class PassportComponent {
    @Input() public relation?: RelationInterface;
    @Input() public passportProducts?: PassportProduct[];
}
